import { useT } from '@/i18n/LanguageContext';

/** Compact JA/EN language switch. Japanese is canonical; EN is a generated
 *  view produced by the local LLM, so a subtle notice replaces silence when
 *  translation is unavailable. */
export default function LanguageToggle({ className = '' }) {
  const { lang, setLang, translationDegraded, retryTranslation } = useT();
  return (
    <div className="inline-flex items-center gap-2" data-no-translate>
      <div
        className={`inline-flex items-center rounded-full border border-zinc-200 bg-zinc-50 p-0.5 ${className}`}
        data-testid="language-toggle"
      >
        {[['ja', '日本語'], ['en', 'EN']].map(([l, label]) => (
          <button
            key={l}
            type="button"
            data-testid={`lang-${l}`}
            onClick={() => setLang(l)}
            aria-pressed={lang === l}
            className={`relative px-2.5 h-7 rounded-full text-xs font-semibold transition-colors after:absolute after:-inset-1 after:content-[''] ${
              lang === l ? 'bg-white text-teal-700 shadow-sm' : 'text-zinc-500 hover:text-zinc-700'
            }`}
          >
            {label}
          </button>
        ))}
      </div>
      {translationDegraded && (
        <span
          className="hidden xl:inline-flex max-w-[360px] items-center gap-1.5 truncate rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-[11px] text-amber-900"
          role="status"
          title="English translation is temporarily unavailable. Showing the original Japanese."
          data-testid="translation-degraded"
        >
          English translation is temporarily unavailable. Showing the original Japanese.
          <button type="button" onClick={retryTranslation}
            data-testid="translation-retry"
            className="font-semibold underline decoration-dotted hover:text-amber-950">
            Retry
          </button>
        </span>
      )}
    </div>
  );
}
